var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMood = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 21"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.714,
  height: 16.714,
  x: 2.09,
  y: 1.643,
  fill: "#fff",
  rx: 8.357
}), /*#__PURE__*/React.createElement("path", {
  fill: "#838383",
  d: "M10.445 13.242a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M10.447 15.082a.45.45 0 0 1-.464-.445V14.6c0-.256.209-.465.464-.465s.464.21.464.465-.209.482-.464.482m3.315-1.309a.48.48 0 0 1-.33-.134l-.06-.06a.462.462 0 1 1 .655-.655l.06.06a.462.462 0 0 1-.325.79m-6.63 0a.462.462 0 0 1-.33-.79l.06-.06a.462.462 0 1 1 .655.655l-.06.06a.47.47 0 0 1-.325.135m7.958-3.315h-.037a.466.466 0 0 1-.465-.464c0-.255.21-.464.465-.464s.483.209.483.464a.45.45 0 0 1-.446.464m-9.249 0h-.037a.466.466 0 0 1-.464-.464c0-.255.209-.464.464-.464s.483.209.483.464a.45.45 0 0 1-.446.464m7.86-3.254a.462.462 0 0 1-.33-.79l.061-.06a.462.462 0 1 1 .655.654l-.06.06a.46.46 0 0 1-.325.136m-6.509 0a.48.48 0 0 1-.33-.135l-.06-.065a.462.462 0 1 1 .655-.655l.06.06a.46.46 0 0 1 0 .655.45.45 0 0 1-.325.14m3.255-1.37a.45.45 0 0 1-.464-.446v-.037c0-.255.209-.464.464-.464s.464.209.464.464-.209.483-.464.483"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 22.286,
  height: 22.286,
  x: -0.696,
  y: 0.25,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.393
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.393
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "multiply",
  result: "effect1_dropShadow_3417_109085"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3417_109085",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.348
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  mode: "multiply",
  result: "effect2_innerShadow_3417_109085"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.393
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.696
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_innerShadow_3417_109085",
  result: "effect3_innerShadow_3417_109085"
})))));
export { SvgMood as ReactComponent };
export default __webpack_public_path__ + "static/media/mood.f1f6553b113f81efb65046a4be2bde83.svg";